import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

import type { PaymentHistoryFiltersType } from '@pages/organizer/Finance/components/tabs/PaymentHistory/store/payment-history-types';
import type { PaymentHistoryDashboardType } from '@pages/organizer/Finance/components/tabs/PaymentHistory/store/payment-history-types';
import type { PaymentHistoryState } from '@pages/organizer/Finance/components/tabs/PaymentHistory/store/payment-history-types';
import type { WalletPaymentAccountType } from '@pages/organizer/Finance/components/tabs/Wallet/store/wallet-types';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { TransactionModal } from '@shared/models/transactions/transaction.model';
const startOfMonth = moment().subtract(5, 'month').startOf('month').startOf('day').format('YYYY-MM-DD');
const endOfMonth = moment().endOf('month').endOf('day').format('YYYY-MM-DD');
const initialState: PaymentHistoryState = {
  isFetchingInitialData: false,
  isFetchingWithFilter: false,
  paymentList: { data: [], meta: { next_cursor: null, count: 0 } },
  isListOver: false,
  accountsList: { data: [], meta: { net_balance: 0 } },
  dashboardInfo: null,
  filters: {
    account_ids: null,
    item_ids: null,
    query: null,
    hubs: null,
    category_ids: null,
    date_to: endOfMonth,
    date_from: startOfMonth,
  },
};

export const paymentHistorySlice = createSlice({
  name: 'paymentHistory',
  initialState,
  reducers: {
    addTransactionItem: (state, action: PayloadAction<TransactionModal>) => {
      state.paymentList.data.push(action.payload);
      state.paymentList.meta.count = state.paymentList.meta.count + 1;
    },
    updateTransactionItem: (state, action: PayloadAction<TransactionModal>) => {
      state.paymentList.data = state.paymentList.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
    },
    setPaymentHistoryAccountsList: (
      state,
      action: PayloadAction<{ data: WalletPaymentAccountType[]; meta: { net_balance: number } }>,
    ) => {
      state.accountsList = action.payload;
    },
    setPaymentHistoryList: (
      state,
      action: PayloadAction<{
        data: TransactionModal[];
        meta: { next_cursor: number | null; count: number };
      }>,
    ) => {
      state.paymentList = action.payload;
      state.isListOver = !action.payload.meta.next_cursor;
    },

    setMorePaymentHistoryList: (
      state,
      action: PayloadAction<{
        data: TransactionModal[];
        meta: { next_cursor: number | null; count: number };
      }>,
    ) => {
      state.paymentList = {
        ...action.payload,
        data: [...state.paymentList.data, ...action.payload.data],
      };
      state.isListOver = !action.payload.meta.next_cursor;
    },
    setPaymentHistoryFilters: (state, action: PayloadAction<PaymentHistoryFiltersType>) => {
      state.filters = action.payload;
    },
    setPaymentHistoryDashboardInfo: (state, action: PayloadAction<PaymentHistoryDashboardType>) => {
      state.dashboardInfo = action.payload;
    },
    removeTransactionItem: (state, action: PayloadAction<number>) => {
      state.paymentList.data = state.paymentList.data.filter((item) => item.id !== action.payload);
      state.paymentList.meta.count = state.paymentList.meta.count - 1;
    },

    resetPaymentHistoryData: () => {
      return { ...initialState };
    },
  },
});

export const {
  addTransactionItem,
  updateTransactionItem,
  removeTransactionItem,
  setPaymentHistoryFilters,
  resetPaymentHistoryData,
  setPaymentHistoryList,
  setPaymentHistoryAccountsList,
  setPaymentHistoryDashboardInfo,
  setMorePaymentHistoryList,
} = paymentHistorySlice.actions;
export default paymentHistorySlice.reducer;
